import React from 'react'
import { AnimateKeyframes } from 'react-simple-animate'
import purpleBackground from 'assets/svgs/purple-background.svg'
import playmaker from 'assets/svgs/playmaker.svg'

export const AppGenerateTutorialLoader = () => {
  return (
    <div className="w-full flex items-center justify-center py-8">
      <div className="relative w-full max-w-2xl rounded-2xl overflow-hidden shadow-lg">
        {/* Background */}
        <img
          src={purpleBackground}
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover"
        />

        {/* Content */}
        <div className="relative z-10 flex items-center p-8">
          {/* Playmaker Icon */}
          <div className="flex-shrink-0 mr-8">
            <img src={playmaker} alt="Playmaker" className="w-64 h-auto" />
          </div>

          {/* Text Content */}
          <div className="text-white">
            <span className="text-sm text-white mb-2">
              My assistant coaches are gathering the latest resources for you —
            </span>
            <span className="text-sm text-white font-bold mb-2">
              {' it should only take a moment!'}
            </span>
            <div className="flex items-center text-sm text-white mt-1">
              <span className="text-white">Generating Tutorials {'  '}</span>
              <div className="flex space-x-1.5 ml-2 items-end" style={{ height: '8px' }}>
                <AnimateKeyframes
                  play
                  iterationCount="infinite"
                  duration={1.2}
                  delay={0}
                  keyframes={[
                    'transform: translateY(0px)',
                    'transform: translateY(-4px)',
                    'transform: translateY(0px)',
                  ]}
                >
                  <div className="w-1 h-1 bg-white rounded-full"></div>
                </AnimateKeyframes>
                <AnimateKeyframes
                  play
                  iterationCount="infinite"
                  duration={1.2}
                  delay={0.3}
                  keyframes={[
                    'transform: translateY(0px)',
                    'transform: translateY(-4px)',
                    'transform: translateY(0px)',
                  ]}
                >
                  <div className="w-1 h-1 bg-white rounded-full"></div>
                </AnimateKeyframes>
                <AnimateKeyframes
                  play
                  iterationCount="infinite"
                  duration={1.2}
                  delay={0.6}
                  keyframes={[
                    'transform: translateY(0px)',
                    'transform: translateY(-4px)',
                    'transform: translateY(0px)',
                  ]}
                >
                  <div className="w-1 h-1 bg-white rounded-full"></div>
                </AnimateKeyframes>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
